import script from "./BuscadorSectionHome.vue?vue&type=script&setup=true&lang=js"
export * from "./BuscadorSectionHome.vue?vue&type=script&setup=true&lang=js"

import "./BuscadorSectionHome.vue?vue&type=style&index=0&id=a4d86d0a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a4d86d0a"]])

export default __exports__